import PaginatedTable from 'components/common/table/paginated-table';
import * as React from 'react';
import { FilterableRoles, PaymentStatuses } from './participation-filter';

export const rolesFilter = PaginatedTable.SelectFilter('role', 'Role', {
  [FilterableRoles.COACH]: 'Coach',
  [FilterableRoles.COMMISSIONER]: 'Commissioner',
  [FilterableRoles.LEAGUE_OWNER]: 'League Owner',
  [FilterableRoles.MANAGER]: 'Manager',
  [FilterableRoles.NON_PLAYER]: 'Non-Player',
  [FilterableRoles.PLAYER]: 'Player',
  [FilterableRoles.TEAM_OWNER]: 'Team Owner',
});

export const gendersFilter = PaginatedTable.SelectFilter('gender', 'Gender', {
  Male: 'Male',
  Female: 'Female',
  Unknown: '[Not Listed]',
});

export const birthdateFilter = PaginatedTable.DateFilter(
  'birthdate',
  'Birthdate',
  '[No Birthdate]',
  '2007, 2008, 2009',
  null,
  new Date().toISOString().split('T')[0]
);

export const paymentFilter = PaginatedTable.SelectFilter(
  'payment',
  'Payment',
  [
    { value: PaymentStatuses.PAID, label: 'Paid' },
    { value: PaymentStatuses.UNPAID, label: 'Unpaid' },
    { value: PaymentStatuses.SCHEDULED, label: 'Scheduled' },
    { value: PaymentStatuses.REFUNDED, label: 'Refunded' },
    { value: PaymentStatuses.FAILED, label: 'Failed' },
    { value: PaymentStatuses.NO_FEES, label: 'No Fees' },
  ],
  <div style={{ maxWidth: '180px' }}>
    <a
      href="https://helpme.teamsnap.com/article/1742-participant-payment-statuses"
      rel="noreferrer"
      target="_blank"
    >
      Click to learn more about payment statuses.
    </a>
  </div>,
  'https://helpme.teamsnap.com/article/1742-participant-payment-statuses'
);
